// Predicate-generating function. Often useful outside of Underscore.
export default function noop(){}



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/noop.js
// module id = 298
// module chunks = 8